import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';
import { createEpicMiddleware } from 'redux-observable';
import history from 'src/history';
import rootReducers from 'status/partial/reducers';
import rootEpics from 'status/partial/epics';
import saveAuthToLocal from 'status/middlewares/saveAuthToLocal';
import saveStaffToLocal from 'status/middlewares/saveStaffToLocal';
import saveStoreToLocal from 'status/middlewares/saveStoreToLocal';


const reducers = combineReducers({
  form: formReducer,
  router: connectRouter(history),
  ...rootReducers,
});

let composeEnhancers = compose;
if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ serialize: true });
}

const epicMiddleware = createEpicMiddleware();

const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(
    epicMiddleware,
    routerMiddleware(history),
    saveStoreToLocal,
    saveStaffToLocal,
    saveAuthToLocal,
  )),
);
epicMiddleware.run(rootEpics);
export default store;
